import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
    private loadingCount = 0;
    private loadingSubject = new BehaviorSubject<boolean>(false);

    loading$ = this.loadingSubject.asObservable();

    show() {
        this.loadingCount++;
        // console.log('SHOW', this.loadingCount);
        this.loadingSubject.next(true);
    }

    hide() {
        this.loadingCount--;
        // console.log('HIDE', this.loadingCount);
        if (this.loadingCount <= 0) {
            this.loadingCount = 0;
            this.loadingSubject.next(false);
        }
    }
}
